/*global define*/

define(function () {
    'use strict';

    function http($httpProvider) {

        $httpProvider.useApplyAsync(true);
    }

    http.$inject = ['$httpProvider'];

    return http;
});



/** WEBPACK FOOTER **
 ** ./~/ng-annotate-loader/loader.js!./src/javascripts/ng-admin/Main/config/http.js
 **/